import CustomerAddPopup from "./CustomerAddPopup";

export default CustomerAddPopup;
